const dayjs = require('dayjs').default
const listApi = '/app/open/hall/kb/list'
const type = [
    {
        label: '工程',
        filter: {
            type: 0,
        },
    },
    {
        label: '货物',
        filter: {
            type: 1,
        },
    },
    {
        label: '服务',
        filter: {
            type: 2,
        },
    },
]
const filter = {
    startDate: dayjs().subtract(3, 'month').toDate(),
    endDate: dayjs().toDate(),
    filter: '',
    type: 1,
    pbType: 16,
}
const mixin = {
    data() {
        return {
            timerList1: [],
            timerList2: [],
            timerList3: [],
        }
    },
    methods: {
        clearTimer(timerList) {
            for (let index = 0; index < timerList.length; index++) {
                clearInterval(timerList[index].timer)
            }
        },
        setTimer(timerList) {
            for (let index = 0; index < timerList.length; index++) {
                timerList[index].timer = setInterval(() => {
                    timerList[index].value.restTime = this.$util.getMinusTime(timerList[index].value[timerList[index].targetKbTime])
                }, 1000)
            }
        },
        typeChange() {
            for (let index = 0; index < 2; index++) {
                this.clearTimer(this[`timerList${index + 1}`])
            }
            this.setTimer(this[`timerList${this.active + 1}`])
        },
        mappingData(arr, pageIndex) {
            return arr.map((t) => {
                t._id = t.pbType === 8 ? t.preTrialBdGuid : t.afterTrialBdGuid
                const targetKbTime = t.pbType === 8 ? 'preTrialOpenBidTime' : 'afterTrialOpenBidTime'
                t[targetKbTime] = dayjs(t[targetKbTime]).valueOf() // 还原开标时间
                this.$set(t, 'restTime', t[targetKbTime] - (new Date()).valueOf() > 0 ? this.$util.getMinusTime(t[targetKbTime]) : '已截标')
                this.$set(t, 'kbStatus', t[targetKbTime] - (new Date()).valueOf() > 0 > 0 ? 1 : 3)
                this.$set(t, 'kbTimeText', dayjs(t[targetKbTime]).format('YYYY-MM-DD HH:mm'))
                // 刷新时(请求第一页,清空该页所有定时器)
                if (pageIndex === 1) {
                    this.clearTimer(this[`timerList${this.active + 1}`])
                }
                // 防止产生重复定时器
                const existTimer = this[`timerList${this.active + 1}`].find((x) => x.value.id === t.id)
                if (existTimer) {
                    clearInterval(existTimer.timer)
                    this[`timerList${this.active + 1}`].splice(this[`timerList${this.active + 1}`].indexOf(existTimer), 1)
                }
                if (t[targetKbTime] - (new Date()).valueOf() > 0) {
                    const timer = setInterval(() => {
                        t.restTime = this.$util.getMinusTime(t[targetKbTime])
                    }, 1000)
                    this[`timerList${this.active + 1}`].push({
                        timer: timer,
                        value: t,
                        targetKbTime: t[targetKbTime],
                    })
                }
                return t
            })
        },
        onConfirm(date) {
            const [start, end] = date
            this.filter.startDate = dayjs(start).format('YYYY-MM-DD')
            this.filter.endDate = dayjs(end).format('YYYY-MM-DD')
            this.show = false
            this.date = `${this.filter.startDate} - ${this.filter.endDate}`
            this.refreshing = true
            this.refresh()
        },
    },
    activated() {
        this.setTimer(this[`timerList${this.active + 1}`])
    },
    deactivated() {
        for (let index = 0; index < 2; index++) {
            this.clearTimer(this[`timerList${index + 1}`])
        }
    },
}

module.exports = {
    listApi,
    filter,
    mixin,
    type,
}
